import React, { Component } from 'react';
import Link from 'gatsby-link';

import { Container, Row, Column } from './grid';

class GridDemo extends Component {
  render() {
    return (
    <div style={{ position: 'fixed', left: '0', right: '0', top: '0', bottom: '0', pointerEvents: 'none', zIndex: '999' }}>
      <Container style={{ borderLeft: '1px solid red', borderRight: '1px solid red', boxSizing: 'content-box' }}>
        <Row margins={false} style={{ background: 'repeating-linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) 10px, rgba(255, 255, 255, 0.5) 10px, rgba(255, 255, 255, 0.5) 20px)', opacity: '0.6' }}>
        {
            [
                '#00BFA5',
                '#64FFDA',
                '#00BFA5',
                '#64FFDA',
                '#00BFA5',
                '#64FFDA',
                '#00BFA5',
                '#64FFDA',
                '#00BFA5',
                '#64FFDA',
                '#00BFA5',
                '#64FFDA',
            ].map( (element, index) => {
                return ( <Column key={index} cw={1} mcw={1} style={{ height: '100vh', background: `${element}`, boxSizing: 'border-box', opacity: '0.7' }}>
                            <div style={{ width: '100%', height: '100vh', background: 'teal', borderLeft: '1px solid white', borderRight: '1px solid white', boxSizing: 'border-box' }}></div>
                        </Column> )
                } )
        }
        </Row>
      </Container>
    </div>
  )}
}

export default GridDemo;



// WEBPACK FOOTER //
// ./src/components/global/grid/grid-demo.js